module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"Empty","leaveComment":"Leave a comment","goBack":"Go back"}}')
  delete Component.options._Ctor
}
